module.exports = __webpack_public_path__ + "img/imagen5.79c8e6a7.png";